export const POOL_STATUS_ALL = 'All'
export const POOL_STATUS_ONLINE = 'Online'
export const POOL_STATUS_OFFLINE = 'Offline'
export const POOL_STATUS_INACTIVE = 'Inactive'

export const normalizePoolStatus = (status, legacyIsOffline) => {
  if (status) {
    return status
  }

  if (legacyIsOffline === true || legacyIsOffline === 'true') {
    return POOL_STATUS_OFFLINE
  }

  if (legacyIsOffline === false || legacyIsOffline === 'false') {
    return POOL_STATUS_ONLINE
  }

  return POOL_STATUS_ALL
}



// WEBPACK FOOTER //
// ./src/constants/poolStatuses.js